module.exports = __webpack_public_path__ + "img/3U.d2718d0f.png";